import {
  SelectOption,
  SelectOptionsOrGroups,
  SortableMultiselect,
} from '@ardoq/select';
import { LabelFormattingComponentProperties } from '../../types';
import { Tag, TAG_BUTTON_SELECTOR, TAG_DIV_SELECTOR } from '@ardoq/status-ui';
import { commonInputStyle, InputStyleProps } from '@ardoq/forms';
import styled from 'styled-components';
import { spacing } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';

const DisabledFieldsSelectContainer = styled.div<InputStyleProps>`
  ${commonInputStyle};
  padding: 2px ${spacing.s8} 6px;
  ${TAG_DIV_SELECTOR}, ${TAG_BUTTON_SELECTOR} {
    margin-right: ${spacing.s4};
    margin-top: ${spacing.s4};
  }
`;
type DisabledFieldsSelectProps = {
  selectedOptions: SelectOption<string>[];
};
const DisabledFieldsSelect = ({
  selectedOptions,
}: DisabledFieldsSelectProps) => {
  return (
    <DisabledFieldsSelectContainer>
      <FlexBox gap="xsmall" flexWrap>
        {selectedOptions.map(option => (
          <Tag key={option.value}>{option.label}</Tag>
        ))}
      </FlexBox>
    </DisabledFieldsSelectContainer>
  );
};

type FieldsSelectProps = {
  index: number;
  fieldOptions: SelectOptionsOrGroups<string>;
  selectedOptions: SelectOption<string>[];
  hasFieldsWarning: boolean;
  onUpdateLabelFormattingAt: LabelFormattingComponentProperties['onUpdateLabelFormattingAt'];
  isDisabled: boolean;
};
const FieldsSelect = ({
  index,
  fieldOptions,
  selectedOptions,
  hasFieldsWarning,
  onUpdateLabelFormattingAt,
  isDisabled,
}: FieldsSelectProps) => {
  if (isDisabled) {
    return <DisabledFieldsSelect selectedOptions={selectedOptions} />;
  }

  const warningMessage = hasFieldsWarning
    ? 'Selecting more than 4 fields might make the label too long and make the view look cluttered'
    : undefined;

  return (
    <SortableMultiselect
      menuPortalTarget={null}
      placeholder="Search and select field"
      options={fieldOptions}
      value={selectedOptions}
      onChange={option =>
        onUpdateLabelFormattingAt(index, {
          fields: option
            ? Array.from(option.values()).map(option => option.value)
            : [],
        })
      }
      warningMessage={warningMessage}
    />
  );
};
export { FieldsSelect };
